/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepeatPhoneConfirmRequestGetSuccess
 */
export interface RepeatPhoneConfirmRequestGetSuccess {

    /**
     * 
     * @type {string}
     * @memberof RepeatPhoneConfirmRequestGetSuccess 
     */
    phone: string;

    /**
     * 
     * @type {string}
     * @memberof RepeatPhoneConfirmRequestGetSuccess 
     */
    phoneCall: string;

    /**
     * 
     * @type {string}
     * @memberof RepeatPhoneConfirmRequestGetSuccess 
     */
    status: string;

    /**
     * 
     * @type {string}
     * @memberof RepeatPhoneConfirmRequestGetSuccess 
     */
    token: string;

    /**
     * Через сколько секунд после этого запроса звонка можно запросить код по SMS
     * @type {number}
     * @memberof RepeatPhoneConfirmRequestGetSuccess
     */
    smsAvailableIn?: number;
}

export function RepeatPhoneConfirmRequestGetSuccessFromJSON(json: any): RepeatPhoneConfirmRequestGetSuccess {
    return RepeatPhoneConfirmRequestGetSuccessFromJSONTyped(json, false);
}

export function RepeatPhoneConfirmRequestGetSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepeatPhoneConfirmRequestGetSuccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }

    return {
        'token': json['data']['token'],
        'phone': json['data']['phone'],
        'status': json['data']['status'],
        'phoneCall': json['data']['phoneCall'],
        'smsAvailableIn': json['data']['smsAvailableIn'],
    };
}

export function RepeatPhoneConfirmRequestGetSuccessToJSON(value?: RepeatPhoneConfirmRequestGetSuccess | null): any {
    if (value === undefined) {
        return undefined;
    }

    if (value === null) {
        return null;
    }

    return {
        'token': value.token,
        'phone': value.phone,
        'status': value.status,
        'phoneCall': value.phoneCall,
    };
}


